module.exports = __webpack_public_path__ + "static/media/mobile-alt.1e3b02c0.svg";